import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  select(event) {
    const name = event.currentTarget.dataset.tabName
    this.tabTargets.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tabName === name)))
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabName !== name
    })
  }
}
